import axios, { AxiosRequestConfig as OriginalAxiosRequestConfig } from 'axios';
import { Nullable } from 'vitest';
import { authHeaderRequestInterceptor } from './auth-header-interceptor';
import { createCacheInterceptors } from './cache-interceptor';
import { queryParamsInterceptor } from './query-params-interceptor';
import {
  requestDurationLoggerRequestInterceptor,
  requestDurationLoggerResponseInterceptorOnFulfilled,
  requestDurationLoggerResponseInterceptorOnRejected,
} from './request-duration-logger-interceptor';
import { requestErrorLoggerResponseInterceptorOnRejected } from './request-error-logger-interceptor';
import { secretHeaderInterceptor } from './secret-header-interceptor';
import { sessionIdRequestInterceptor } from './sessionIdInterceptor';

declare module 'axios' {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  export interface AxiosRequestConfig<T = unknown> extends OriginalAxiosRequestConfig<T> {
    metadata?: { requestStart?: number; cached?: boolean };
    useCache?: boolean;
    sessionId?: string | null;
    userId?: number | null;
    secret?: Nullable<string>;
    // FIXME does not cover all possible filter combinations, like gt, lt, etc.
    filter?: Record<string, string | number | boolean | string[] | number[]>;
  }
}

export const axiosClient = axios.create();

// add request duration logger interceptor
axiosClient.interceptors.request.use(requestDurationLoggerRequestInterceptor);
axiosClient.interceptors.response.use(
  requestDurationLoggerResponseInterceptorOnFulfilled,
  requestDurationLoggerResponseInterceptorOnRejected
);
axiosClient.interceptors.response.use((response) => response, requestErrorLoggerResponseInterceptorOnRejected);
// add cache interceptor
const { cacheRequestInterceptor, cacheResponseInterceptorOnFulfilled } = createCacheInterceptors(axios);
axiosClient.interceptors.request.use(cacheRequestInterceptor);
axiosClient.interceptors.response.use(cacheResponseInterceptorOnFulfilled);
// add secret interceptor
axiosClient.interceptors.request.use(secretHeaderInterceptor);
// add session id interceptor
axiosClient.interceptors.request.use(sessionIdRequestInterceptor);
// add auth header interceptor
axiosClient.interceptors.request.use(authHeaderRequestInterceptor);
axiosClient.interceptors.request.use(queryParamsInterceptor);
